import { render, staticRenderFns } from "./CrNotesReg.vue?vue&type=template&id=80dfe6c6"
import script from "./CrNotesReg.vue?vue&type=script&lang=js"
export * from "./CrNotesReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports